import {InjectionToken} from '@angular/core';
import {SignResponseExtractor} from '@atlas/convertor';

/**
 * @deprecated Provide the `SignResponseExtractor` class directly instead
 */
export const SIGN_RESPONSE_EXTRACTOR_TOKEN = new InjectionToken<SignResponseExtractor>(
  'Sign Response Extractor',
);
